// A menu of choices with an icon, a title and a description each (roles, share permissions),
// with a check on the current one.
import type { ReactNode } from 'react';
import clsx from 'clsx';
import { Check, type IconComponent } from '@/components/ui/icons';
import { Menu } from './Menu';

export interface MenuOption<K extends string> {
  key: K;
  label: string;
  description?: string;
  icon?: IconComponent;
  danger?: boolean;
}

export function OptionMenu<K extends string>({
  options,
  value,
  onPick,
  children,
}: {
  options: MenuOption<K>[];
  value?: K | null;
  onPick: (key: K) => void;
  /** extra items under the options (a separator and an action, say) */
  children?: ReactNode;
}) {
  return (
    <Menu className="option-menu">
      {options.map(({ key, label, description, icon: Icon, danger }) => (
        <button key={key} type="button" role="menuitemradio" aria-checked={key === value} className={clsx('option-item', { danger })} onClick={() => onPick(key)}>
          {Icon && (
            <span className="option-item-icon">
              <Icon size={17} />
            </span>
          )}
          <span className="option-item-text">
            <span className="option-item-label">{label}</span>
            {description && <span className="option-item-desc">{description}</span>}
          </span>
          <span className="option-item-check">{key === value && <Check size={15} />}</span>
        </button>
      ))}
      {children}
    </Menu>
  );
}
